import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    />
  );
};

export default SvgIcon;
